function accessibilityJS() {
    
    // Adding Titles to Iframes
    const videoPlayer = document.querySelector('[data-video]');
    if (document.body.contains(videoPlayer)) {
        const video = document.querySelectorAll('[data-video]');
        for (let i = 0; i < video.length; i++) {
            const videoTitle = video[i].dataset.videoTitle;  
            const videoIframe = video[i].querySelector('iframe');
            
            if (videoIframe && videoTitle) {
                videoIframe.setAttribute('title', videoTitle);    
            }
                        
        }

    }
    
    /**
    * @title Link & Image Attribute Filler
    * @description Add Missing Attributes to Links & Images
    */
    
    const linksRel = document.querySelectorAll('a[rel=""], a:not([rel])');
    const linksTitle = document.querySelectorAll('a[title=""], a:not([title])');
    
    for (let i = 0; i < linksRel.length; i++) {
        if (linksRel[i].host !== window.location.host) {
            linksRel[i].rel = 'noreferrer';    
        }
    }
    
    for (let i = 0; i < linksTitle.length; i++) {
        if (linksTitle[i].dataset.link && linksTitle[i].dataset.link !== 'disabled') {
            const linkHref = linksTitle[i].href;
            linksTitle[i].title = 'This is a link for ' + linkHref;    
        }
    }
    
    const imageMissingAttributes = document.querySelectorAll('img[title=""], img[alt=""]');
    
    for (let i = 0; i < imageMissingAttributes.length; i++) {
        const imageSrc = imageMissingAttributes[i].src.substring(imageMissingAttributes[i].src.lastIndexOf('/') + 1);
        imageMissingAttributes[i].title = imageSrc.split('.').slice(0, -1).join('.');
        imageMissingAttributes[i].alt = imageSrc.split('.').slice(0, -1).join('.');
    }    
    
}

export default accessibilityJS;